// extracted by mini-css-extract-plugin
export default {"wrapper":"DTQKsGRdhw6VWwn5VjNL","attention":"p_8Nym1LXDS7j6BxahBJ","bounce":"qFhHwSUvIP0Vbh3ihic9"};